import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Accordion Header Component
 */
@Component({
  selector: 'atx-accordion-header',
  template: '<div data-e2e="header"><ng-content></ng-content></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccordionHeaderComponent {}
